import axios from 'axios';
import { settings } from '../config';
export async function getTasks(type: string, provider?: string) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = `${settings.url}tasks/${type}`;
    const response = provider
      ? await axios.get(url, { ...config, params: { provider: provider } })
      : await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function recordTaskProgress(
  type: string,
  id: number,
  provider?: string,
) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = `${settings.url}tasks/${type}/record/${id}`;
    const response = provider
      ? await axios.post(url, { provider: provider }, config)
      : await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function claimTask(
  type: string,
  id: number | string,
  provider?: string,
) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = provider
      ? `${settings.url}tasks/${type}/reward/${id}?provider=${provider}`
      : `${settings.url}tasks/${type}/reward/${id}`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function checkTask(
  type: string,
  id: number | string,
  provider?: string,
) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${initData}`,
      'Developer-Token': '8019992060:AAF7UDTOIi0L-1H8QMg1VxMtNnvs0K2y0VA',
    },
  };
  try {
    const url = `${settings.url}tasks/${type}/check/${id}?provider=${provider}`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
export const getAdMasterWidget = async (): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const user = tg?.initDataUnsafe?.user;

  if (!user) {
    throw new Error('Telegram WebApp not initialized');
  }

  const payload = {
    tg_user_id: 5056024242,
    tg_user_locale: user.language_code,
    tg_user_first_name: user.first_name,
    keep_limit: 123,
    tg_user_is_premium: user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  try {
    const response = await axios.post(
      `https://app.barzha.com/api/widget/67`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при получении AdMaster виджета:', error);
    throw error;
  }
};

export const clickAdMasterWidget = async (campaignId: string): Promise<any> => {
  const tg = window?.Telegram?.WebApp;
  const user = tg?.initDataUnsafe?.user;

  if (!user || !campaignId) {
    throw new Error('Telegram WebApp not initialized or missing campaign ID');
  }

  const payload = {
    tg_user_id: 5056024242,
    tg_user_locale: user.language_code,
    tg_user_first_name: user.first_name,
    keep_limit: 123,
    tg_user_is_premium: user.is_premium || false,
    tg_user_platform: tg.platform,
  };

  try {
    const response = await axios.post(
      `https://app.barzha.com/api/widget/click/67/${campaignId}`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при клике по AdMaster виджету:', error);
    throw error;
  }
};

export async function getCPCBanner() {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${encodeURIComponent(initData)}`,
    },
  };

  try {
    const url = `${settings.url}tasks/cpc/banners`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
export async function postCPCBannerClick(bannerId: string) {
  if (!window.Telegram?.WebApp?.initData) {
    throw new Error('Telegram WebApp or initData is not available');
  }
  const initData = window.Telegram.WebApp.initData;
  const config = {
    headers: {
      Authorization: `Bearer ${encodeURIComponent(initData)}`,
    },
  };

  try {
    const url = `${settings.url}tasks/cpc/actions?banner_id=${bannerId}`;

    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
